// This file should be shared between API and frontend.
// It is basically a copy from API project.

import { z } from "zod";

const FromParticipant = z.object({
  type: z.literal('participant'),
  id: z.literal('__any__').or(z.string().nonempty()),
});

const FromTag = z.object({
  type: z.literal('tag'),
  tag: z.string().nonempty(),
});

const FromOrganization = z.object({
  type: z.literal('organization'),
  qrId: z.string().nonempty().optional(),
});

const ToWallet = z.object({
  type: z.literal('wallet'),
  id: z.string().nonempty(),
});

const ToParticipant = z.object({
  type: z.literal('participant'),
  id: z.string().nonempty(),
});
const ToTag = FromTag;

const RuleBody = z.object({
  percent: z.coerce.number({message: 'Must be number'}).int().min(0).max(100),
});

export const PaymentRuleDataV1Schema = z.object({
  version: z.literal(1),
  distribution: z.object({
    byOrganization: RuleBody.extend({
      from: FromOrganization,
      to: ToWallet.or(ToParticipant).or(ToTag),
    }).array(),
    byParticipant: RuleBody.extend({
      from: FromParticipant,
      to: ToWallet.or(ToParticipant).or(ToTag),
    }).array(),
    byTag: RuleBody.extend({
      from: FromTag,
      to: ToWallet.or(ToParticipant),
    }).array(),
  }),
});

// there can be OR used in the future, to represent multiple versions
export const PaymentRuleDataSchema = PaymentRuleDataV1Schema;